<template>
    <b-card header="New Provider"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="saveProfile()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name" label-for="firstname">
                        <b-form-input
                                id="firstname"
                                name="firstname"
                                type="text"
                                v-model="form.firstname"
                                required
                        >
                        </b-form-input>
                        <input-help :form="form" field="firstname" text="Enter their first name."></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name" label-for="lastname">
                        <b-form-input
                                id="lastname"
                                name="lastname"
                                type="text"
                                v-model="form.lastname"
                                required
                        >
                        </b-form-input>
                        <input-help :form="form" field="lastname" text="Enter their last name."></input-help>
                    </b-form-group>
                    <b-form-group label="Language">
                        <b-form-select v-model="form.language" readonly>
                            <option value="en">English</option>
                            <!-- <option value="fr">French</option>
                            <option value="es">Spanish</option> -->
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Email Address" label-for="email">
                        <b-form-input
                                id="email"
                                name="email"
                                type="email"
                                v-model="form.email"
                                :disabled="form.no_email"
                        >
                        </b-form-input>
                        <input-help :form="form" field="email" text="Enter their email address."></input-help>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <b-button variant="success" type="submit">Create Provider</b-button>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    export default {
        props: {},

        data() {
            return {
                form: new Form({
                    firstname: null,
                    lastname: null,
                    email: null,
                    date_of_birth: null,
                    ssn: null,
                    password: null,
                    password_confirmation: null,
                    title: null,
                    no_email: false,
                    enrollment_status: 'enrolled',
                    created_at: moment().format('MM/DD/YYYY'),
                    language: 'en',
                })
            }
        },

        mounted() {
        },

        methods: {

            saveProfile() {
                this.form.post('/business/caregivers');
            }

        }


    }
</script>
